"use client";

import { analyticsUrl } from "@/lib/analyticsUrl";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { useSession } from "next-auth/react";
import {
  logAnalyticsEvent,
  buildAnalyticsBase,
} from "@/utils/hive";

export default function AnalyticsInit() {
  const pathname = usePathname();
  const { data: session } = useSession();

  useEffect(() => {
    const referrer = document.referrer || null;

    let isExternal = false;

    if (referrer) {
      try {
        const referrerUrl = new URL(referrer);

        isExternal =
          referrerUrl.hostname !== window.location.hostname;
      } catch {
        isExternal = false;
      }
    }

    const url = new URL(window.location.href);

    const utmSource =
      url.searchParams.get("utm_source");

    const utmMedium =
      url.searchParams.get("utm_medium");

    const utmCampaign =
      url.searchParams.get("utm_campaign");

    const payload = buildAnalyticsBase({
      session,

      currentTrack: null,

      currentPlaylistId: null,

      currentType: null,

      durationSec: 0,

      referrer: isExternal ? analyticsUrl(referrer, window.location.origin) : null,

      utmSource,
      utmMedium,
      utmCampaign,

      landingPage: analyticsUrl(window.location.href, window.location.origin),
    });

    payload.type = "page_view";

    logAnalyticsEvent(payload);
  }, [pathname, session]);

  return null;
}